import { Epic } from "redux-observable";
import { of } from "rxjs";
import { catchError, filter, mergeMap } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { Dependencies } from "../../../services/index";
import { RootState } from "../../rootReducer";
import { RootAction } from "../../types";
import { AccountResponse } from "./../../../services/accounts";
import { createAccountAsync, fetchAccountsAsync } from "./actions";

export const createAccountEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Dependencies
> = (action$, _, { createAccount }) =>
  action$.pipe(
    filter(isActionOf(createAccountAsync.request)),
    mergeMap(({ payload }) => {
      return createAccount(payload).pipe(
        mergeMap((account: AccountResponse) =>
          of(createAccountAsync.success(account))
        ),
        catchError((error) => of(createAccountAsync.failure(error)))
      );
    })
  );

export const fetchAccountsEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Dependencies
> = (action$, _, { fetchAccounts }) =>
  action$.pipe(
    filter(isActionOf(fetchAccountsAsync.request)),
    mergeMap(() => {
      return fetchAccounts().pipe(
        mergeMap((accounts: AccountResponse[]) =>
          of(fetchAccountsAsync.success(accounts))
        ),
        catchError((error) => of(fetchAccountsAsync.failure(error)))
      );
    })
  );
